import React from 'react'
import { Helmet } from 'react-helmet'

export const scriptSpecialCases = (script = {}) => {

  const { name, source, id, siteId } = script

  //para los casos especiales
  const cases = {
    'google-analytics': (
      <Helmet key={id}>
        <script key={id}>
          {`window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${source.match(/G-([\w\d]+)/g)}');`}
        </script>
      </Helmet>
    ),
    'facebook-pixel': (
      <Helmet key={id}>
        <script key={id}>
          {`!function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window,document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${source}');
            fbq('track', 'PageView');`}
        </script>
        <noscript>
          {`<img
            height="1"
            width="1"
            src={'https://www.facebook.com/tr?id=${source}&ev=PageView&noscript=1}'/>`}
        </noscript>
      </Helmet>
    ),
    'matomo-tag-manager': (
      <Helmet key={id}>
        <script key={id}>
          {`
            var _paq = window._paq = window._paq || [];
            /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
            _paq.push(['trackPageView']);
            _paq.push(['enableLinkTracking']);

            (function() {
              var u="${source}"; // Replace with your Matomo URL ("//matomo.ucc.edu.ar/")
              _paq.push(['setTrackerUrl', u+'matomo.php']);
              _paq.push(['setSiteId', '${siteId}']); // Replace with your Matomo site ID
              var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
              g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
            })();
          `}
        </script>
      </Helmet>
    )
  }
   // google-tag-manager se importa en gatsby-config.js
  return cases[name] || null
}
